module.exports = __webpack_public_path__ + "static/media/kayal.fc15c111.jpg";